export const IMPRIMIR_BOLETO_ABE_WEB_ACTION = '@boleto/IMPRIMIR_BOLETO_ABE_WEB_ACTION';
export const IMPRIMIR_BOLETO_DELPHI_ACTION = '@boleto/IMPRIMIR_BOLETO_DELPHI_ACTION';
export const IMPRIMIR_BOLETO_CLIENTE_DELPHI_ACTION = '@boleto/IMPRIMIR_BOLETO_CLIENTE_DELPHI_ACTION';
export const BUSCAR_PARAMETROS_GERAR_BOLETO_ACTION = '@boleto/BUSCAR_PARAMETROS_GERAR_BOLETO_ACTION';

export const SET_PARAMETROS_DECRIPTOGRAFADOS_ACTION = '@boleto/SET_PARAMETROS_DECRIPTOGRAFADOS_ACTION';
